import React, { useCallback, useMemo, useState } from "react";
import { getCurrentUser } from "../utils/auth";
import { usePermissions } from "../utils/permissions";
import { getUserAccessInfo } from "../utils/accessFilters";
import { buildAccessHeaders } from "../utils/accessHeaders";
import Walmart810Batch from "./Walmart810Batch";
import Walmart810Reconciliation from "./Walmart810Reconciliation";

export default function Walmart810() {
  const user = getCurrentUser();
  const { getLevel, refresh: refreshPermissions } = usePermissions();
  const [mode, setMode] = useState("reconciliation");
  const [batchInitialLoadId, setBatchInitialLoadId] = useState("");
  const [mutationLocked, setMutationLocked] = useState(false);
  const [writeDenied, setWriteDenied] = useState(false);
  const level = getLevel(user?.role, "edi-810");
  const full = level === "Full" && !writeDenied;
  const headers = useMemo(() => {
    const access = getUserAccessInfo();
    return buildAccessHeaders(access.user, access, { includeCust: true, includeWhs: false });
  }, []);

  const downgradePermission = useCallback(async () => {
    setWriteDenied(true);
    await Promise.resolve().then(() => refreshPermissions()).catch(() => {});
  }, [refreshPermissions]);

  const openBatch = useCallback((loadId) => {
    if (mutationLocked) return;
    setBatchInitialLoadId(String(loadId || "").trim());
    setMode("batch");
  }, [mutationLocked]);

  const changeMode = (nextMode) => {
    if (!mutationLocked) setMode(nextMode);
  };

  return <main className="mx-auto max-w-7xl space-y-5 p-6" aria-labelledby="walmart-810-title">
    <header>
      <h1 id="walmart-810-title" className="text-2xl font-semibold text-gray-900">Walmart 810</h1>
      <p className="mt-1 text-sm text-slate-600">Review the server-authoritative invoice population and safely process eligible invoices.</p>
    </header>
    <nav aria-label="Walmart 810 workflow mode" className="inline-flex rounded border bg-white p-1">
      <button type="button" disabled={mutationLocked} aria-pressed={mode === "reconciliation"} onClick={() => changeMode("reconciliation")} className={`rounded px-4 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 ${mode === "reconciliation" ? "bg-blue-700 text-white" : "text-slate-700"}`}>Reconciliation</button>
      <button type="button" disabled={mutationLocked} aria-pressed={mode === "batch"} onClick={() => changeMode("batch")} className={`rounded px-4 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 ${mode === "batch" ? "bg-blue-700 text-white" : "text-slate-700"}`}>Batch 810</button>
    </nav>
    {mode === "reconciliation"
      ? <Walmart810Reconciliation headers={headers} onOpenBatch={openBatch}/>
      : <Walmart810Batch full={full} headers={headers} initialLoadId={batchInitialLoadId} onPermissionDenied={downgradePermission} onMutationChange={setMutationLocked}/>}
  </main>;
}
